// MSAL imports
import { MsalProvider } from '@azure/msal-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createBrowserHistory } from 'history';
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.scss';
import { Footer, Header, Loading } from './components';
import LoginGate from './components/LoginGate';
import PrivateRoute from './components/PrivateRoute';
import ScrollToTop from './components/scrollToTop';
import SyncProfile from './components/syncProfile/SyncProfile';
import NotFound from './pages/NotFound';
import Routes from './routes';

// eslint-disable-next-line react/prop-types
function App({ pca }) {
  const history = createBrowserHistory();

  const renderComponent = (route, props) => {
    const Component = route.component;
    if (route?.loginGate) {
      return <LoginGate component={Component} />;
    }
    if (route?.isPrivate) {
      return <PrivateRoute component={Component} />;
    }
    return <Component {...props} />;
  };

  return (
    <>
      <Router history={history}>
        <Suspense fallback={<Loading />}>
          <MsalProvider instance={pca}>
            <SyncProfile />
            <Header />
            <Switch>
              {Routes().map(route => <Route key={route.path} path={route.path} exact={route.exact} render={props => renderComponent(route, props)} />)}
              <Route component={NotFound} />
            </Switch>
            <ScrollToTop />
            <Footer />
          </MsalProvider>
        </Suspense>
      </Router>
    </>
  );
}

export default App;
